import React from "react";
import { SsnFormat, ssnFormatForLabel } from "utils/formatSsn";
interface IOptions {
  key: string;
  label: string;
  type: string;
  placeHolder: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  // Set for a custom field the cluster labels as an SSN; LoginForm adds the
  // dashes as digits are typed.
  ssnFormat?: SsnFormat;
}
// customLabels holds the cluster's own names for its custom fields (for example
// { custom1: "SSN" }); a field without one keeps the generic "Custom N" name.
const AuthOptions = (key: string, customLabels?: Record<string, string>) => {
  const customLabel = customLabels?.[key]?.trim();
  if (customLabel) {
    const ssnFormat = ssnFormatForLabel(customLabel);
    if (ssnFormat) {
      return {
        key,
        type: "text",
        label: customLabel,
        placeHolder:
          ssnFormat === "ssn-last4" ? "Last 4 digits" : "123-45-6789",
        inputMode: "numeric",
        ssnFormat,
      } as IOptions;
    }
    return {
      key,
      type: "text",
      label: customLabel,
      placeHolder: `Enter ${customLabel}`,
    } as IOptions;
  }

  const option: IOptions[] = [
    {
      key: "accountid",
      label: "Account ID",
      type: "text",
      placeHolder: "Enter Account ID",
    },
    {
      key: "first_name",
      label: "First Name",
      type: "text",
      placeHolder: "Enter First name",
    },
    {
      key: "birthday",
      label: "Birthday",
      type: "text",
      // The login reads MM/DD/YYYY; LoginForm adds the slashes as digits
      // are typed, so the number pad is enough.
      placeHolder: "MM/DD/YYYY",
      inputMode: "numeric",
    },
    {
      key: "last_name",
      label: "Last Name",
      type: "text",
      placeHolder: "Enter Last name",
    },
    {
      key: "phone_number",
      label: "Phone Number",
      type: "tel",
      placeHolder: "Enter your phone number",
    },
    {
      key: "postal_code",
      label: "Postal Code",
      type: "text",
      placeHolder: "Enter Postal Code",
    },
    {
      key: "email",
      label: "Email",
      type: "email",
      placeHolder: "Enter Email Id",
    },
    {
      key: "custom1",
      type: "text",
      label: "Custom 1",
      placeHolder: "Enter Custom1",
    },
    {
      key: "custom2",
      type: "text",
      label: "Custom 2",
      placeHolder: "Enter Custom2",
    },
    {
      key: "custom3",
      type: "text",
      label: "Custom 3",
      placeHolder: "Enter Custom3",
    },
    {
      key: "custom4",
      type: "text",
      label: "Custom 4",
      placeHolder: "Enter Custom4",
    },
    {
      key: "custom5",
      type: "text",
      label: "Custom 5",
      placeHolder: "Enter Custom5",
    },
    {
      key: "custom6",
      type: "text",
      label: "Custom 6",
      placeHolder: "Enter Custom6",
    },
    {
      key: "custom7",
      type: "text",
      label: "Custom 7",
      placeHolder: "Enter Custom7",
    },
    {
      key: "custom8",
      type: "text",
      label: "Custom 8",
      placeHolder: "Enter Custom8",
    },
    {
      key: "custom9",
      type: "text",
      label: "Custom 9",
      placeHolder: "Enter Custom9",
    },
    {
      key: "custom10",
      type: "text",
      label: "Custom 10",
      placeHolder: "Enter Custom10",
    },
    {
      key: "custom11",
      type: "text",
      label: "Custom 11",
      placeHolder: "Enter Custom11",
    },
    {
      key: "custom12",
      type: "text",
      label: "Custom 12",
      placeHolder: "Enter Custom12",
    },
    {
      key: "custom13",
      type: "text",
      label: "Custom 13",
      placeHolder: "Enter Custom13",
    },
    {
      key: "custom14",
      type: "text",
      label: "Custom 14",
      placeHolder: "Enter Custom14",
    },
    {
      key: "custom15",
      type: "text",
      label: "Custom 15",
      placeHolder: "Enter Custom15",
    },
    {
      key: "custom16",
      type: "text",
      label: "Custom 16",
      placeHolder: "Enter Custom16",
    },
    {
      key: "custom17",
      type: "text",
      label: "Custom 17",
      placeHolder: "Enter Custom17",
    },
    {
      key: "custom18",
      type: "text",
      label: "Custom 18",
      placeHolder: "Enter Custom18",
    },
    {
      key: "custom19",
      type: "text",
      label: "Custom 19",
      placeHolder: "Enter Custom19",
    },
    {
      key: "custom20",
      type: "text",
      label: "Custom 20",
      placeHolder: "Enter Custom20",
    },
  ];
  return option.find((field) => field.key === key);
};

export default AuthOptions;
